module.exports = __webpack_public_path__ + "img/f.95bd97d3.jpg";